import { render, staticRenderFns } from "./PageFilters.vue?vue&type=template&id=2a0477d9&scoped=true&"
import script from "./PageFilters.vue?vue&type=script&lang=js&"
export * from "./PageFilters.vue?vue&type=script&lang=js&"
import style0 from "./PageFilters.vue?vue&type=style&index=0&id=2a0477d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0477d9",
  null
  
)

export default component.exports